import { isNil } from 'lodash-es';
import { TDispatch, TGetState } from 'state';
import { LocalStorageItems } from '../../../../../../constants';
import { IPageInfo } from '../types';
import { setPageInfo } from '.';

const changePageInfo = (pageInfo: Partial<IPageInfo> = {}, forceUpdate = false) => {
  return (dispatch: TDispatch, getState: TGetState): void => {
    const { isLoading, pageInfo: currentPageInfo } = getState().moderation.messages;
    const sortBy = pageInfo['sortBy'] ?? currentPageInfo['sortBy'];
    const shouldUpdatePageInfo: boolean = Object.keys(pageInfo).some(
      prop => !isNil(currentPageInfo[prop]) && pageInfo[prop] !== currentPageInfo[prop]
    );

    if (forceUpdate || (!isLoading && shouldUpdatePageInfo)) {
      dispatch(setPageInfo({ pageInfo: { ...pageInfo, offset: pageInfo.offset || 0 } }));
      localStorage.setItem(LocalStorageItems.ModerationFilterCriteria, JSON.stringify({ sortBy }));
    }
  };
};

export default changePageInfo;
